[
    {
        "title": "MEN",
        "subcategories": [
            {
                "title": "New Arrivals",
                "subcategories": [
                    {
                        "title": "New This Week",
                        "url": "/men/shop/new-this-week?optionId=7&title=New This Week"
                    },
                    {
                        "title": "New This Month",
                        "url": "/men/shop/new-this-month?optionId=8&title=New This Month"
                    },
                    {
                        "title": "All New Arrivals",
                        "url": "/men/shop/all-new-arrivals?optionId=1&title=All New Arrivals"
                    }
                ]
            },
            {
                "title": "Shop By",
                "subcategories": [
                    {
                        "title": "For You",
                        "url": "/men/shop/for-you?optionId=3&title=For You"
                    },
                    {
                        "title": "The Edit",
                        "url": "/men/edit"
                    },
                    {
                        "title": "Shoppable Videos",
                        "url": "/men/videos"
                    },
                    {
                        "title": "Trending Now",
                        "url": "/men/shop/trending?optionId=6&title=Trending Now"
                    }
                ]
            },
            {
                "title": "Designers",
                "url": "/men/designers"
            },
            {
                "title": "Clothing",
                "url": "/men/shop/clothing?page=1&title=Clothing&filters=",
                "subcategories": [
                    {
                        "title": "All Clothing",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters="
                    },
                    {
                        "title": "Coats & Jackets",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters=category%3Dcoats-and-jackets"
                    },
                    {
                        "title": "Shirts",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters=category%3Dpolo-shirts"
                    },
                    {
                        "title": "Suits",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters=category%3Dsuits"
                    },
                    {
                        "title": "Pants",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters=category%3Dpants"
                    },
                    {
                        "title": "Bottoms",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters=category%3Dbottoms"
                    },
                    {
                        "title": "Knitwear",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters=category%3Dknitwear"
                    },
                    {
                        "title": "Jumpsuits",
                        "url": "/men/shop/clothing?page=1&title=Clothing&filters=category%3Djumpsuits"
                    }
                ]
            },
            {
                "title": "Bags",
                "url": "/men/shop/all-new-arrivals?optionId=1&title=All+New+Arrivals&filters=parent-category%3Dbags&page=1",
                "subcategories": [
                    {
                        "title": "All Bags",
                        "url": "/men/shop/all-new-arrivals?optionId=1&title=All+New+Arrivals&filters=parent-category%3Dbags&page=1"
                    },
                    {
                        "title": "Handbags",
                        "url": "/men/shop/all-new-arrivals?optionId=1&title=All+New+Arrivals&filters=category%3Dhandbags&page=1"
                    }
                ]
            },
            {
                "title": "Accessories",
                "url": "/men/shop/accessories?page=1&title=Accessories&filters=",
                "subcategories": [
                    {
                        "title": "All Accessories",
                        "url": "/men/shop/accessories?page=1&title=Accessories&filters="
                    },
                    {
                        "title": "Gloves",
                        "url": "/men/shop/accessories?page=1&title=Accessories&filters=category%3Dgloves"
                    },
                    {
                        "title": "Sunglasses",
                        "url": "/men/shop/accessories?page=1&title=Accessories&filters=category%3Dsunglasses"
                    },
                    {
                        "title": "Wallets",
                        "url": "/men/shop/accessories?page=1&title=Wallets&filters=category%3Dwallets-__and__-cardholders"
                    }
                ]
            },
            {
                "title": "Grooming",
                "url": "/men/shop/grooming?page=1&title=Grooming&filters=",
                "subcategories": [
                    {
                        "title": "All Grooming",
                        "url": "/men/shop/grooming?page=1&title=Grooming&filters="
                    },
                    {
                        "title": "Personal Care",
                        "url": "/men/shop/grooming?page=1&title=Grooming&filters=category%3Dpersonal-care"
                    },
                    {
                        "title": "Hair Care",
                        "url": "/men/shop/grooming?page=1&title=Grooming&filters=category%3Dhair-care"
                    },
                    {
                        "title": "Cosmetics",
                        "url": "/men/shop/grooming?page=1&title=Grooming&filters=category%3Dcosmetics"
                    },
                    {
                        "title": "Sleeping Aids",
                        "url": "/men/shop/grooming?page=1&title=Grooming&filters=category%3Dsleeping-aids"
                    }
                ]
            },
            {
                "title": "Home",
                "url": "/men/shop/home?page=1&title=Home&filters=",
                "subcategories": [
                    {
                        "title": "All Home",
                        "url": "/men/shop/home?page=1&title=Home&filters="
                    },
                    {
                        "title": "Barware",
                        "url": "/men/shop/home?page=1&title=Home&filters=category%3Dbarware"
                    },
                    {
                        "title": "Books",
                        "url": "/men/shop/home?page=1&title=Home&filters=category%3Dbooks"
                    },
                    {
                        "title": "Bath",
                        "url": "/men/shop/home?page=1&title=Home&filters=category%3Dbath"
                    },
                    {
                        "title": "Towels",
                        "url": "/men/shop/home?page=1&title=Home&filters=category%3Dtowels"
                    },
                    {
                        "title": "Umbrellas",
                        "url": "/men/shop/home?page=1&title=Home&filters=category%3Dumbrellas"
                    }
                ]
            },
            {
                "title": "Jewelry & Watches",
                "url": "/men/shop/jewelry-&-watches?page=1&title=Jewelry+and+Watches&filters=",
                "subcategories": [
                    {
                        "title": "All Jewelry & Watches",
                        "url": "/men/shop/jewelry-&-watches?page=1&title=Jewelry+and+Watches&filters="
                    },
                    {
                        "title": "Watches",
                        "url": "/men/shop/jewelry-%26-watches?page=1&title=Jewelry+and+Watches&filters=category%3Dsmart-watches~dress-watches~diving-watches"
                    },
                    {
                        "title": "Bracelets",
                        "url": "/men/shop/jewelry-%26-watches?page=1&title=Jewelry+and+Watches&filters=category%3Dbracelets"
                    },
                    {
                        "title": "Rings",
                        "url": "/men/shop/jewelry-%26-watches?page=1&title=Jewelry+and+Watches&filters=category%3Drings"
                    },
                    {
                        "title": "Earrings",
                        "url": "/men/shop/jewelry-%26-watches?page=1&title=Jewelry+and+Watches&filters=category%3Dearrings"
                    }
                ]
            },
            {
                "title": "Sport",
                "url": "/men/shop/sport?page=1&title=Sport&filters=",
                "subcategories": [
                    {
                        "title": "All Sports",
                        "url": "/men/shop/sport?page=1&title=Sport&filters="
                    },
                    {
                        "title": "Yoga & Pilates",
                        "url": "/men/shop/sport?page=1&title=Sport&filters=category%3Dyoga-__and__-pilates"
                    },
                    {
                        "title": "Ski",
                        "url": "/men/shop/sport?page=1&title=Sport&filters=category%3Dski-and-snow"
                    },
                    {
                        "title": "Activewear",
                        "url": "/men/shop/sport?page=1&title=Sport&filters=category%3Dactivewear"
                    },
                    {
                        "title": "Tennis",
                        "url": "/men/shop/sport?page=1&title=Sport&filters=category%3Dtennis"
                    }
                ]
            },
            {
                "title": "AI Stylist Search",
                "url": "/men/ai-stylist"
            },
            {
                "title": "Concierge Services",
                "subcategories": [
                    {
                        "title": "Digital Closet"
                    },
                    {
                        "title": "Outfit"
                    },
                    {
                        "title": "White Glove Digitization",
                        "url": "/men/white-glove-digitization"
                    }
                ]
            }
        ]
    }
]
